import { ReactNode, useEffect, useState } from "react";
import type { UseBoundStore } from "zustand";
import { getConnectPhantomURL, isMobile, isPhantomBrowser } from "./services";

const ConnectPhantom = ({
  add: add = false,
  disabled: disabled = false,
  onClick: onClick = () => {},
  children,
  store,
}: {
  add?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  children?: ReactNode;
  store: UseBoundStore<any>;
}) => {
  const authToken = store((state) => state.authToken);
  const [url, setUrl] = useState("");
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const _mobile = isMobile() && !isPhantomBrowser();
    setMobile(_mobile);
    const _url = getConnectPhantomURL("", !!(add || authToken), authToken);
    // console.log("ConnectPhantom", _url);
    if (_url) setUrl(_url);
  }, []);

  return mobile ? (
    <a
      className="flex flex-row justify-center items-center bg-transparent border-none w-full h-full"
      href={disabled ? "" : url}
    >
      {children}
    </a>
  ) : (
    <button
      className="flex flex-row justify-center items-center w-full h-full"
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default ConnectPhantom;
